import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ButtonComponent } from '../button/button.component';
import { StrokedButtonComponent } from '../stroked-button/stroked-button.component';

@Component({
  selector: 'ctr-option-modal',
  imports: [ButtonComponent, StrokedButtonComponent],
  templateUrl: './option-modal.component.html',
  styleUrl: './option-modal.component.scss',
})
export class OptionModalComponent {
  @Input() title: string | undefined;
  @Input() description: string | undefined;
  @Input() yesText: string | undefined;
  @Input() noText: string | undefined;
  @Output() action: EventEmitter<boolean> = new EventEmitter<boolean>();

  clickYes() {
    this.action.emit(true);
  }

  clickNo() {
    this.action.emit(false);
  }
}
